import React from "react";
import useReveal from "@/hooks/useReveal";

export default function Reveal({ children, delay = 0, as: As = "div", className = "" }) {
  const { ref, visible } = useReveal();
  return (
    <As
      ref={ref}
      className={`reveal ${visible ? "in-view" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </As>
  );
}
